export const config = {
    name: 'businessPlan',

    selection: true,
    index: false,
    tableData: {
        columns: [
            {
                label: '用户',
                prop: 'customerCode',
                align: 'center'
            },
            {
                label: '大类',
                prop: 'category',
                align: 'center'
            },
            {
                label: '小类',
                type: 'text',
                prop: 'statusClass'
            },
            {
                label: '权重',
                minWidth: 100,
                prop: 'industryCategories'
            },
            {
                label: '年度目标',
                prop: 'customerGroup',
                minWidth: 120
            },
            {
                label: '累计达成',
                prop: 'customerLevel'
            },

            {
                label: '年度达成率',
                prop: 'logisticsScale',
                minWidth: 150
            },

            {
                label: '累计预算',
                prop: 'cooperationScale',
                minWidth: 100
            },
            {
                label: '累计预算达成率',
                prop: 'money',
                minWidth: 100
            },
            {
                label: '累计得分',
                prop: 'promiseSigningPlan',
                minWidth: 100
            }

        ]
    }
};

export const formList = {
    customerList: [
        {
            label: '客户编码：',
            prop: 'customerCode'
        },
        {
            label: '客户名称：',
            prop: 'customerName'
        },
        {
            label: '客户开发人：',
            prop: 'customerOwnerName'
        },
        {
            label: '客户系：',
            prop: 'customerGroupName'
        },

        {
            label: '客户等级：',
            prop: 'customerLevelCode',
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
        },
        {
            label: '行业大类：',
            prop: 'industryCategoriesName'
            // industryCategories
        },
        {
            label: '细分行业：',
            prop: 'industryTypeName'
        },
        {
            label: '客户状态：',
            prop: 'customerStatus',
            optionsKey: 'SYS_WM_CUSTOMER_STATUS'
        },
        {
            label: '内外渠：',
            prop: 'customerChannel',
            optionsKey: 'LMDM_CUSTOMER_CHANNEL'
        }

    ],
    opportunityList: [
        {
            label: '商机编码：',
            prop: 'opportunityCode'
        },
        {
            label: '商机名称：',
            prop: 'opportunityName'
        },

        {
            label: '商机大类：',
            prop: 'businessType',
            type: 'select',
            optionsKey: 'NEOCRM_BUSINESS_TYPE'
        },
        {
            label: '分公司：',
            prop: 'companyName'
        },
        {
            label: '经营中心：',
            prop: 'businessCenterName'
        },
        {
            label: '商机状态：',
            prop: 'opportunityStatus',
            optionsKey: 'NEOCRM_OPPORTUNITY_STATUS'
        }

    ],
    contractList: [
        {
            label: '合同编码：',
            prop: 'contractCode'
        },
        {
            label: '合同名称：',
            prop: 'contractName'
        },
        {
            label: '会计主体：',
            prop: 'accountEntityName'
        },
        {
            label: '业务类别：',
            prop: 'businessType',
            optionsKey: 'SYS_BMS_BUSI_TYPE'
        },
        {
            label: '生效日期：',
            prop: 'validTime'
        },
        {
            label: '失效日期：',
            prop: 'failTime'
        },
        {
            label: '合同状态：',
            prop: 'contractStatus',
            optionsKey: 'SYS_CR_CONTRACT_STATUS'
        }

    ]
};
